import { useContext } from 'react';
import { styled } from "@mui/material";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Button from "../../../../customs/Button";
import { NotificationContext } from '../../../../providers/notification';
import apiCall from '../../../../utils/apiCall';

interface ComponentProps {
    zoneId: number;
    zoneName: string;
    handleClose: () => void;
}

const DeleteZone: React.FC<ComponentProps> = ({ zoneId, zoneName, handleClose }) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);

    const deleteZone = (id: number) => {
        return apiCall().delete(`/Zone/DelZone/${id}`);
    };

    const deleteZoneMutation = useMutation(['delete-zone'], deleteZone, {retry: 0});

    const deleteZoneHandler = async (id : number) => {
        try { 
            await deleteZoneMutation.mutateAsync(id, {
                onSuccess: () => {
                    showNotification({
                        message: 'Zone successfully disabled',
                        type: 'success'
                    })
                    queryClient.refetchQueries(['get-zones']);
                    handleClose();
                }
            })
        } catch (error: any) {
            showNotification({
                message: error?.response?.data?.title || error?.message,
                type: 'error',
            })
        }
    };

    const handleDeleteZone = (id : number) => deleteZoneHandler(id);
    return (
        <StyledContainer>
            <StyledText>You are about to delete <strong>{zoneName}</strong></StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton onClick={handleClose} text='Cancel'/>
                    <StyledButton 
                        type="submit" 
                        text={deleteZoneMutation.isLoading ? 'Deleting...' : 'Yes, Delete'} 
                        onClick={() => handleDeleteZone(zoneId)}
                        disabled={deleteZoneMutation.isLoading}
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DeleteZone;

const StyledContainer = styled('div')`
    margin-inline: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    background-color: #DD5151;
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`